'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


// Utils


// Constants


var _lodash = require('lodash');

var _immutableHelper = require('../../../common/utils/immutableHelper');

var _point = require('../../../common/maths/geometry/point');

var pointsLib = _interopRequireWildcard(_point);

var _gridUtils = require('../../utils/grid/gridUtils');

var _boardConstants = require('../../../common/boards/boardConstants');

var _clamp = require('../../../common/maths/clamp');

var _clamp2 = _interopRequireDefault(_clamp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getUpdatedLocation = function getUpdatedLocation(_ref) {
    var dropResult = _ref.dropResult,
        offsetsMap = _ref.offsetsMap,
        elementId = _ref.elementId,
        gridSize = _ref.gridSize;

    // If the element is dropped onto the TRASH or INBOX then we don't need to make any updates to their position here
    if (dropResult.location.section === _boardConstants.BOARD_SECTIONS.INBOX || dropResult.location.section === _boardConstants.BOARD_SECTIONS.TRASH) {
        return (0, _lodash.cloneDeep)(dropResult.location);
    }

    var elementOffset = (0, _gridUtils.positionPixelsToGridPoints)(offsetsMap[elementId], gridSize);
    var position = pointsLib.translate(dropResult.location.position, elementOffset);
    // Prevent the element from disappearing off the canvas
    position = (0, _lodash.mapValues)(position, (0, _clamp2.default)(0, Infinity));

    return _extends({}, dropResult.location, {
        position: position
    });
};

var makeAddToMovesArrayReducer = function makeAddToMovesArrayReducer(_ref2) {
    var dropResult = _ref2.dropResult,
        offsetsMap = _ref2.offsetsMap,
        gridSize = _ref2.gridSize,
        measurementsMap = _ref2.measurementsMap;
    return function (movesArray, elementId) {
        var location = getUpdatedLocation({ dropResult: dropResult, offsetsMap: offsetsMap, elementId: elementId, gridSize: gridSize });
        movesArray.push({ id: elementId, location: location });
        return movesArray;
    };
};

exports.default = function (_ref3) {
    var dropResult = _ref3.dropResult,
        item = _ref3.item,
        gridSize = _ref3.gridSize,
        measurementsMap = _ref3.measurementsMap;
    var offsetsMap = item.offsetsMap;


    var addToMovesArrayReducer = makeAddToMovesArrayReducer({ dropResult: dropResult, offsetsMap: offsetsMap, gridSize: gridSize });

    return dropResult.acceptedElementIds.sort(function (idA, idB) {
        return (0, _immutableHelper.propIn)([idA, 'top'], measurementsMap) - (0, _immutableHelper.propIn)([idB, 'top'], measurementsMap);
    }).reduce(addToMovesArrayReducer, []);
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/dnd/buildElementMovesArray.js
// module id = 1971
// module chunks = 0